<template>
    <div class="flex">
        <RouterLink class="flex flex-col" :to="{ name: 'dashboard' }">
            <img src="@/assets/logo.webp" class="max-w-32" alt="logo">
            <span class="text-enim-primary font-semibold uppercase">{{ $t('general.administration') }}</span>
        </RouterLink>
    </div>
</template>

<script lang="ts" setup>
</script>
